// extracted by mini-css-extract-plugin
module.exports = {"arrow":"style_arrow__3k9u6","spin":"style_spin__3Wqzj","rightSide":"style_rightSide__1lmaH","leftSide":"style_leftSide__29W2M"};